module.exports = __webpack_public_path__ + "static/media/cover3.b34f053f.png";